// extracted by mini-css-extract-plugin
export default {"root":"SubHeader_root__iUS3D","breadcrumb":"SubHeader_breadcrumb__fIAp3","btn-group":"SubHeader_btn-group__G404W","date":"SubHeader_date__OXCrz"};